export default __webpack_public_path__ + "static/japan-flag-9732671ed52dbf8f6f30ad0597816b01.svg";